import { PARAM_CHANGE } from '@store/actions';
import BLOCKS from '@store/blocks';

import testUiData from '@constants/test.json';

const TestKeys = Object.keys(testUiData.testOptions);

export function RESET_MAP_PICKABLE_PARAMS(store) {
  PARAM_CHANGE(store, BLOCKS.MAP.CROSSHAIR_SETTING, -1);
  PARAM_CHANGE(store, BLOCKS.MAP.ACTIVE_MARKERS, [
    { x: -1, y: -1 },
    { x: -1, y: -1 },
  ]);
  PARAM_CHANGE(store, BLOCKS.MAP.PICKING_MARKER, { x: -1, y: -1 });
}
export function RESET_TEST(store) {
  PARAM_CHANGE(store, BLOCKS.TEST_PANELS.ACTIVE_TEST, '');
  PARAM_CHANGE(store, BLOCKS.MAP.MARKER_COUNT, 0);
}

export function SET_INITIAL_TEST(store) {
  PARAM_CHANGE(store, BLOCKS.TEST_PANELS.ACTIVE_TEST, TestKeys[0]);
}

export function SET_INIT_STEP(store) {
  PARAM_CHANGE(store, BLOCKS.RECON_PANELS.CURRENT_STEP, -1);
}

export function SET_INIT_LOCATION(store) {
  PARAM_CHANGE(store, BLOCKS.HISTORY_PANELS.CURRENT_LOCATION, 'btex');
  PARAM_CHANGE(store, BLOCKS.HISTORY_PANELS.CURRENT_SUBLOCATION, '');
}
/*
export function CROSSHAIR_MOVE_DRIVING(store, pos) {
  PARAM_CHANGE(store, BLOCKS.MAP.ACTIVE_MARKERS, [pos, BLOCKS.MAP.ACTIVE_MARKERS[1]]);
}

export function OPEN_POPUP(store, type) {
  PARAM_CHANGE(store, BLOCKS.APP.POPUP, type);
}
*/
